import {
  ContentHubService,
  FilesService,
  NotificationService,
  ProjectImportService,
  ProjectService,
  TopicService,
  userTokenService,
  ProjectManagementService,
  ContentService,
  ProjectTopicDetailService,
  ContentWorkflowService,
  ReportingService,
  ConnectedContentService,
  CommentApiService,
} from '@pwc/pwc-deals-web-common';
import { routerMiddleware } from 'connected-react-router';
import { EventHub } from '@pwc/event-hub-ui';
import processingMiddleware from '../common/engine/middleware/processingMiddleware';
import rowIngestionMiddleware from '../common/engine/middleware/rowIngestionMiddleware';
import schedulerMiddleware from '../common/engine/middleware/schedulerMiddleware';
import toggleMiddleware from '../common/engine/middleware/toggleMiddleware';
import { history } from './reduxStaticReducers';
import commentMiddleware from '../features/comments/commentMiddleware';
import httpMiddleware from '../Survey/httpMiddleware';
import { insightsApi } from '../features/insights/insightsServiceNew';
import authorizationService from '../common/services/security/authorizationService';

const { getProjectToken } = userTokenService;

window.PWC_EVENT_HUB = window.PWC_EVENT_HUB || { eventHub: new EventHub() };
export const { eventHub } = window.PWC_EVENT_HUB;

const contentHubServiceClient = new ContentHubService(
  process.env.REACT_APP_CONTENT_HUB_SERVICE,
  (projectId) => () => {
    authorizationService.updateProcessTime();
    return userTokenService.getProjectToken(projectId);
  },
  undefined
);

const notificationServiceClient = new NotificationService(
  process.env.REACT_APP_NOTIFICATION_SERVICE,
  (projectId) => () => getProjectToken(projectId),
  undefined,
  eventHub
);

const projectImportServiceClient = new ProjectImportService(
  process.env.REACT_APP_PROJECT_STATE_MANAGEMENT_API_BASE_PATH,
  (projectId) => () => {
    authorizationService.updateProcessTime();
    return userTokenService.getProjectToken(projectId);
  },
  undefined
);

const filesServiceClient = new FilesService(
  process.env.REACT_APP_FILE_LIBRARY_SERVICE,
  (projectId) => () => {
    authorizationService.updateProcessTime();
    return userTokenService.getProjectToken(projectId);
  },
  undefined
);

const projectServiceClient = new ProjectService(
  process.env.REACT_APP_PROJECT_API_BASE_PATH,
  (projectId) => () => getProjectToken(projectId),
  undefined,
  eventHub
);

const topicServiceClient = new TopicService(
  process.env.REACT_APP_CONTENT_SERVICE,
  (projectId) => () => getProjectToken(projectId),
  undefined,
  eventHub
);

const projectManagementServiceClient = new ProjectManagementService(
  process.env.REACT_APP_PROJECT_STATE_MANAGEMENT_API_BASE_PATH,
  (projectId) => () => getProjectToken(projectId),
  undefined,
  eventHub
);

const contentServiceClient = new ContentService(
  process.env.REACT_APP_CONTENT_SERVICE,
  (projectId) => () => getProjectToken(projectId),
  undefined,
  eventHub
);

const projectTopicDetailServiceClient = new ProjectTopicDetailService(
  process.env.REACT_APP_PO_TOPIC_SERVICE,
  (projectId) => () => getProjectToken(projectId),
  undefined,
  eventHub
);

const contentWorkflowServiceClient = new ContentWorkflowService(
  process.env.REACT_APP_CONTENT_WORKFLOW_SERVICE,
  (projectId) => () => getProjectToken(projectId),
  undefined,
  eventHub
);

export const reportingService = new ReportingService(
  process.env.REACT_APP_REPORTING_SERVICE,
  (projectId) => () => getProjectToken(projectId),
  undefined,
  eventHub
);

export const connectedContentServiceClient = new ConnectedContentService(
  process.env.REACT_APP_CONNECTED_CONTENT_API_BASE_PATH,
  (projectId) => () => getProjectToken(projectId),
  undefined,
  eventHub
);

const commentApiServiceClient = new CommentApiService(
  process.env.REACT_APP_COMMENT_API_BASE_PATH,
  (projectId) => () => {
    return userTokenService.getProjectToken(projectId);
  },
  undefined
);

const thunkExtraArguments = {
  contentHubServiceClient,
  notificationServiceClient,
  projectImportServiceClient,
  filesServiceClient,
  projectServiceClient,
  topicServiceClient,
  projectManagementServiceClient,
  contentServiceClient,
  projectTopicDetailServiceClient,
  contentWorkflowServiceClient,
  reportingService,
  connectedContentServiceClient,
  commentApiServiceClient,
};

const commonMiddleware = [
  processingMiddleware,
  schedulerMiddleware,
  rowIngestionMiddleware,
  toggleMiddleware,
];

export const addMiddlewares = (getDefaultMiddleware) =>
  getDefaultMiddleware({
    thunk: { extraArgument: thunkExtraArguments },
    serializableCheck: false,
  }).concat([
    routerMiddleware(history),
    commentMiddleware,
    httpMiddleware,
    insightsApi.middleware,
    ...commonMiddleware,
  ]);
